import { render, staticRenderFns } from "./VideoTag.vue?vue&type=template&id=a58ac954&scoped=true"
import script from "./VideoTag.vue?vue&type=script&lang=js"
export * from "./VideoTag.vue?vue&type=script&lang=js"
import style0 from "./VideoTag.vue?vue&type=style&index=0&id=a58ac954&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a58ac954",
  null
  
)

export default component.exports